import { useEffect, useRef } from "react"
import { useNavigationType } from "react-router-dom"

interface IElementScrollRestoration {
  scrollRef: React.RefObject<Element>
}

export const useElementScrollRestoration = <T extends Element>(
  key: string
): IElementScrollRestoration => {
  const scrollRef = useRef<T>(null)
  const navigationType = useNavigationType()

  const element = scrollRef.current

  useEffect(() => {
    if (!element || !key) {
      return
    }

    const savedPosition = Number(sessionStorage.getItem(key))

    /**
     * NavigationType: "POP" happens when user navigates back to page
     */
    if (savedPosition && navigationType === "POP") {
      element.scrollTo(0, savedPosition)
    }

    sessionStorage.removeItem(key)
  }, [element, key, navigationType])

  useEffect(() => {
    if (!element) {
      return
    }

    const handleScrollEnd = () => {
      const scrollPos = element?.scrollTop
      sessionStorage.setItem(key, scrollPos.toString())
    }

    element.addEventListener("scrollend", handleScrollEnd)

    return () => {
      element.removeEventListener("scrollend", handleScrollEnd)
    }
  }, [element, key])

  return {
    scrollRef,
  }
}
